import { MailCodeOfferStatus } from '../enums/MailCodeOfferStatus';
import { MailCodeOfferField } from '../types/MailCodeOfferField';

export const toOfferStatus = (
  requiredOfferFields: MailCodeOfferField[],
  missingOfferFields: MailCodeOfferField[],
): MailCodeOfferStatus => {
  if (missingOfferFields.length === 0) {
    return MailCodeOfferStatus.COMPLETE;
  }

  return missingOfferFields.length === requiredOfferFields.length
    ? MailCodeOfferStatus.NO_OFFER
    : MailCodeOfferStatus.PARTIAL;
};
